/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ReportingModuleConfig as ɵe} from './lib/common';
export {ReportingTableComponent as ɵa,TradesReportComponent as ɵb} from './lib/components';
export {CreateTradesTableConfigPipe as ɵd,GetKeysPipe as ɵc} from './lib/pipes';
export {ReportsService as ɵf} from './lib/services';